var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{attrs:{"id":"loader"}}),_c('div',{staticClass:"loader-section section-left"}),_c('div',{staticClass:"loader-section section-right"}),_c('div',{staticClass:"load_title"},[_vm._v(" 自动登录授权中... ")])])
}]

export { render, staticRenderFns }